import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { GetOwnUserProfile } from "src/app/_store/user-profile/user-profile.actions";
import { selectOwnUserProfile } from "src/app/_store/user-profile/user-profile.selectors";
import { AppConstants } from "src/app/constants/constants";
import { Roles } from "src/app/constants/Roles";

@Component({
  selector: "app-information-learner-guide",
  templateUrl: "./information-learner-guide.component.html",
  styleUrls: ["./information-learner-guide.component.scss"],
})
export class InformationLearnerGuideComponent implements OnInit, OnDestroy {
  siteLanguageCode: string = this.localeId;
  isLoggedIn: boolean = false;
  pdfSrcDefault: string = ".././assets/pdf/WEST 2 Learner Guide (English).pdf";
  pdfSrcWelsh: string = ".././assets/pdf/WEST 2 Learner Guide (Welsh).pdf";
  pdfSrc: string;
  learnerGuideDestroy$: Subject<void> = new Subject<void>();
  isAdmin: boolean = false;
  adminRoles: Roles[] = [
    Roles.SystemAdministrator,
    Roles.OrganisationalAdministrator,
    Roles.ContentAdministrator,
    Roles.GlobalAdministrator,
    Roles.Tutor,
  ];

  constructor(
    @Inject(LOCALE_ID) protected localeId: string,
    private authService: MsalService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authService.instance.getAllAccounts().length > 0;

    if (this.isLoggedIn) {
      this.store.dispatch(GetOwnUserProfile());
    }

    this.store
      .select(selectOwnUserProfile)
      .pipe(takeUntil(this.learnerGuideDestroy$))
      .subscribe((userProfileResponse: Userprofile) => {
        if (userProfileResponse !== null) {
          this.isAdmin = this.adminRoles.includes(userProfileResponse.roleId);
        }
      });

    if (this.siteLanguageCode) {
      this.pdfSrc =
        this.siteLanguageCode == AppConstants.WELSH_LANG_CODE
          ? this.pdfSrcWelsh
          : this.pdfSrcDefault;
    }
  }

  ngOnDestroy(): void {
    this.learnerGuideDestroy$.next();
    this.learnerGuideDestroy$.unsubscribe();
  }

  downloadPdf(): void {
    if (this.pdfSrc) {
      let link = document.createElement("a");
      link.download = this.pdfSrc.split(AppConstants.SLASH).pop();
      link.href = this.pdfSrc;
      link.click();
    }
  }
}
